export default __webpack_public_path__ + "static/char-s-03-en-e0835505e287e48d10b1986a00058dd8.png";